import React from 'react';
import { Link } from 'react-router-dom';
import { siteConfig } from '../data/mock';

const Footer = () => {
  const footerLinks = [
    { name: 'Disclaimer', path: '/disclaimer' },
    { name: 'Privacy', path: '/privacy' },
    { name: 'Terms and Conditions', path: '/terms' },
    { name: 'Refunds', path: '/refunds' },
    { name: 'Unsubscribe', path: '/unsubscribe' },
    { name: 'Anti-Spam Policy', path: '/antispam' },
    { name: 'Affiliate Disclosure', path: '/affiliate' },
    { name: 'Contact Us', path: '/contact' }
  ];

  return (
    <footer className="bg-gray-100 py-8 mt-12 border-t border-gray-200" role="contentinfo">
      <div className="max-w-4xl mx-auto px-4">
        <nav className="flex flex-wrap justify-center gap-x-4 gap-y-2 mb-6" aria-label="Footer navigation">
          {footerLinks.map((link, index) => (
            <React.Fragment key={link.path}>
              <Link
                to={link.path}
                className="text-gray-600 hover:text-[#cc0000] text-sm transition-colors duration-200"
              >
                {link.name}
              </Link>
              {index < footerLinks.length - 1 && (
                <span className="text-gray-400" aria-hidden="true">|</span>
              )}
            </React.Fragment>
          ))}
        </nav>
        
        <div className="text-center text-gray-500 text-xs space-y-2">
          <p>&copy; {new Date().getFullYear()} {siteConfig.siteName}. All Rights Reserved.</p>
          <address className="not-italic">
            Contact: <a href={`mailto:${siteConfig.contactEmail}`} className="hover:text-[#cc0000]">{siteConfig.contactEmail}</a>
          </address>
          <p>
            ClickBank is the retailer of products on this site. CLICKBANK&reg; is a registered trademark 
            of Click Sales Inc., a Delaware corporation located at 1444 S. Entertainment Ave., Suite 410 
            Boise, ID 83709, USA and used by permission.
          </p>
          <p>
            ClickBank's role as retailer does not constitute an endorsement, approval or review of these 
            products or any claim, statement or opinion used in promotion of these products.
          </p>
          <p className="mt-4 pt-4 border-t border-gray-300">
            This site is not a part of the Facebook website or Facebook Inc. Additionally, this site is NOT endorsed by Facebook or Google in any way. FACEBOOK is a trademark of FACEBOOK, Inc. GOOGLE is a trademark of Google, Inc.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;